import { FractalDAO } from '../types';

export const initialState: FractalDAO = {
  daoAddress: undefined,
  daoContract: undefined,
  daoName: undefined,
  accessControlAddress: undefined,
  accessControlContract: undefined,
  moduleAddresses: undefined,
  isLoading: true,
};
